import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetSocialLibraryV1Response } from './get-social-library-v1-response';
import { getSocialLibraryV1ResponseSchema } from './get-social-library-v1-response';

export async function getSocialLibraryV1Api(): Promise<
  IValidatedResponse<IGetSocialLibraryV1Response>
> {
  return getRequest<IGetSocialLibraryV1Response>({
    path: '/sys/social/v1/library',
    schema: getSocialLibraryV1ResponseSchema,
  });
}
